// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__DAlSg","empty":"ModalGraph_empty__5RHXp"};